// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"References_blockWrapper__ECufl","content":"References_content__PNTV7"};